import React, { useMemo, useRef, useEffect, useState, useImperativeHandle, forwardRef } from 'react'
import cn from 'classnames'
import { flatten } from 'lodash'
import Composition from './Field/Composition'
// import Button from '../button'
import Form from '../form'
// import { getLanguage, getText } from '../prev-locale'
import createActions from './createActions'
import Field from './Field'
import useForm from './useForm'

import './index.less'

const clsPrefix = 'tnt-queryform'

const QueryForm = forwardRef(
  (
    {
      form,
      className = '',
      initialValues: _initialValues,
      language,
      onSearch,
      onReset,
      hasOnChange,
      onChange,
      renderActions,
      extraActions,
      children,
      showSearch = false,
      showReset = false,
      showFieldCount = 3,
      minGroupCount = 3, // 最小聚合个数
      compositionShowReset = true,
      inline,
      defaultSearchField,
      defaultSearchPlaceholder,
    },
    ref
  ) => {
    const [initialValues, setInitialValues] = useState(_initialValues || {})
    const formRef = useRef(form || createActions())

    useImperativeHandle(
      ref,
      () => ({
        form: formRef.current,
      }),
      []
    )

    useEffect(() => {
      const _search = (params = {}) => {
        onSearch?.({
          ...formRef.current.getValues(),
          ...params,
        })
      }
      formRef.current.setData('initialValues', initialValues)
      formRef.current.setData('values', initialValues)
      formRef.current.on('search', _search)
      return () => {
        formRef.current.off('search', _search)
      }
    }, [])

    // const _getText = (key) => {
    //   return getText(key, language || getLanguage())
    // }
    const _onSearch = () => {
      onSearch?.(formRef.current.getValues())
    }

    const _onReset = () => {
      formRef.current.setValues({ ...initialValues })
      onReset?.(initialValues)
      setInitialValues({ ...initialValues })
    }

    const _onFieldChange = (name, value, ...rest) => {
      const values = formRef.current.getValues()
      const newValues = {
        ...values,
        [name]: value,
      }
      const changedInfo = { name, value, preValue: values?.[name] }
      formRef.current.setData('values', newValues)
      onChange && onChange(newValues, changedInfo, ...rest)
    }

    const _onCompositionFieldChange = (value, deleteKeys, needSearch, isReset) => {
      const values = formRef.current.getValues()
      const newValues = {
        ...values,
        ...value,
      }
      const changeKeys = Object.keys(newValues)
      if (deleteKeys?.length) {
        deleteKeys?.forEach((key) => {
          if (values?.[key] || values?.[key] === 0 || values?.[key] === false) {
            delete newValues[key]
          }
        })
      }
      formRef.current.setData('values', newValues)
      if (isReset) {
        return
      } else if (deleteKeys?.length === 1) {
        // 删除一定要搜索
        if (onSearch) {
          onSearch(newValues, true)
        } else {
          onChange(newValues, { name: deleteKeys[0] })
        }
      } else if (needSearch && !hasOnChange) {
        formRef.current.emit('search', { ...newValues, current: 1 })
      } else if (onChange) {
        changeKeys.forEach((key) => {
          if (JSON.stringify(value[key]) !== JSON.stringify(values[key])) {
            const changedInfo = { name: key, value: value[key], preValue: values?.[key] }
            onChange(newValues, changedInfo)
          }
        })
      }
    }

    const [groupFields, outFields, rightChildren, compositionInitValues] = useMemo(() => {
      let groupFields = []
      let outFields = []
      let otherFields = []
      const rightChildren = []
      const compositionInitValues = {}
      React.Children.map(children, (child) => {
        if (child) {
          if (child.props?.align === 'right') {
            rightChildren.push(child)
            return
          } else if (child.props?.isGroup === false) {
            outFields.push(child)
          } else {
            groupFields.push(child)
          }
          otherFields.push(child)
        }
      })
      if (groupFields.length <= minGroupCount) {
        groupFields = []
        outFields = otherFields
      } else {
        // 初始值
        for (let i = 0; i < groupFields.length; i++) {
          const name = groupFields[i].props?.name
          if (initialValues[name] !== undefined) {
            compositionInitValues[name] = initialValues[name]
          }
        }
      }
      return [
        flatten(
          groupFields.map((it) => {
            if (it.props.type === 'selectInput') {
              const { name, props } = it.props || {}
              const { options = [] } = props || {}
              return options.map(({ label, value }) => ({
                props: {
                  pName: name,
                  cName: value,
                  name: `${name}.${value}`,
                  title: label,
                  type: 'otherInput',
                  props: {},
                },
              }))
            } else {
              return it
            }
          })
        ),
        outFields,
        rightChildren,
        Object.keys(compositionInitValues).length > 0 ? compositionInitValues : undefined,
      ]
    }, [children, minGroupCount, initialValues])

    const isGroupMode = groupFields.length > 0
    const hasOutField = outFields.length > 0
    const showExtra = rightChildren.length > 0 || extraActions

    console.log(groupFields)

    return (
      <div className={cn(clsPrefix, className, { [`${clsPrefix}-inline`]: inline })}>
        <Form layout="inline">
          <div className={`${clsPrefix}-top`}>
            <div className={`${clsPrefix}-top-body`}>
              {outFields.map((child, i) =>
                React.cloneElement(child, {
                  form: formRef.current,
                  initialValue: initialValues?.[child.props?.name],
                  onChange: _onFieldChange,
                  key: i,
                })
              )}
              {isGroupMode && (!hasOutField || inline) && (
                <Composition
                  clsPrefix={clsPrefix}
                  fieldItems={groupFields}
                  initialValues={compositionInitValues}
                  _onReset={_onReset}
                  _onSearch={_onSearch}
                  onChange={_onCompositionFieldChange}
                  form={formRef.current}
                  compositionShowReset={compositionShowReset}
                  defaultSearchField={defaultSearchField}
                  defaultSearchPlaceholder={defaultSearchPlaceholder}
                />
              )}
              {renderActions ? (
                renderActions()
              ) : (
                <>
                  {/* {showSearch && (
                    <Button type="primary" onClick={_onSearch}>
                      {_getText('search')}
                    </Button>
                  )}
                  {showReset && <Button onClick={_onReset}>{_getText('reset')}</Button>} */}
                </>
              )}
            </div>
            {showExtra && (
              <div className={`${clsPrefix}-extra`}>
                {rightChildren}
                {extraActions}
              </div>
            )}
          </div>
          {isGroupMode && hasOutField && !inline && (
            <div className={`${clsPrefix}-bottom`}>
              <Composition
                clsPrefix={clsPrefix}
                fieldItems={groupFields}
                initialValues={compositionInitValues}
                _onReset={_onReset}
                _onSearch={_onSearch}
                onChange={_onCompositionFieldChange}
                form={formRef.current}
                compositionShowReset={compositionShowReset}
                defaultSearchField={defaultSearchField}
                defaultSearchPlaceholder={defaultSearchPlaceholder}
              />
            </div>
          )}
        </Form>
      </div>
    )
  }
)

QueryForm.Field = Field
QueryForm.useForm = useForm
QueryForm.createForm = createActions

export default QueryForm
